/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { createSlice } from '@reduxjs/toolkit'
import { RootState } from './store';

// Define a type for the slice state
interface WatchNavigationState {
  isValueChanged: boolean,
}

// Define the initial state using that type
const initialState: WatchNavigationState = {
  isValueChanged: false,
}

export const watchNavigationSlice = createSlice({
  name: 'watchNavigation',
  initialState,
  reducers: {
    setIsValueChanged: (state,action) => {
      state.isValueChanged =action.payload;
    },
  },
})

// Action creators are generated for each case reducer function
export const { setIsValueChanged } = watchNavigationSlice.actions;
export const watchNavigationSelector = (state: RootState) => state.watchNavigation;

export default watchNavigationSlice.reducer;